import React, {ReactElement} from 'react';
import {Typography} from '@customink/pigment-react';

type Props = {
  handleOpenSizingLineup: React.MouseEventHandler;
  sizeLineupURL: string;
};

const SizeLineup: React.FC<Props> = ({
  handleOpenSizingLineup,
  sizeLineupURL
}: Props): ReactElement => {
  return (
    <div>
      <Typography variant="captionLarge">
        <a href={sizeLineupURL} rel="popup" onClick={handleOpenSizingLineup}>
          View Sizing Guide
        </a>
      </Typography>
    </div>
  );
};

export default SizeLineup;
